import React from 'react';
import { industriesData } from '../data/industriesData';

const IndustriesSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-catalina-blue mb-4">Industries We Serve</h2>
          <p className="text-xl text-gray-600">
            Trusted by professionals across diverse industries for reliable material handling solutions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {industriesData.map((industry) => {
            const IconComponent = industry.icon;
            return (
              <div 
                key={industry.id} 
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 flex flex-col items-center justify-center text-center group cursor-pointer"
              >
                <div className="w-16 h-16 bg-catalina-blue rounded-full flex items-center justify-center mb-4 group-hover:bg-san-marino transition duration-300">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-bold text-catalina-blue group-hover:text-san-marino transition duration-300">
                  {industry.name}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;